import { TFunction } from "i18next";
import { Fields } from "../types/SchemaFactory";
import { schemaFactory } from "./SchemaFactory";


import { UpdateUserDTO } from "../domain/models/dto/UpdateUserDTO";

export const updateUserSchemaFields: Fields<UpdateUserDTO> = {
    firstName: {
        min: 2,
        max: 50,
        placeholderKey: "account.accountInformation.firstName",
        type: "text",
        optional: false,
        initial: "",
    },
    lastName: {
        min: 2,
        max: 50,
        placeholderKey: "account.accountInformation.lastName",
        type: "text",
        optional: false,
        initial: "",
    },
    middleName: {
        min: 0,
        max: 50,
        placeholderKey: "account.accountInformation.middleName",
        type: "text",
        optional: true,
        initial: "",
    },
    phone: {
        min: 7,
        max: 20,
        placeholderKey: "account.accountInformation.telephone",
        type: "text",
        optional: false,
        initial: "",
    },
    position: {
        min: 1,
        max: 100,
        placeholderKey: "account.accountInformation.position",
        type: "text",
        optional: false,
        initial: "",
    },
    description: {
        min: 0,
        max: 500,
        placeholderKey: "account.accountInformation.accountDescription",
        type: "text",
        optional: true,
        initial: "",
    },
};


export const updateUserFiltersSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, updateUserSchemaFields);
};

export const updateUserSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, updateUserSchemaFields);
};
